<div id='orAdministrationRoles'>
  <div class='or-content'>
    @if (!isBusy && authorityTypesForBuildingServiceLevel.length > 0) {
      <div class='or-content-body'>
        <ul class='or-stacked-items or-roles-list'>
          @for (role of roles; track role; let i = $index) {
            <li class='or-stacked-item or-roles-list-item'>
              <app-form-role-details [building]='building'
                [role]='role'
                [index]='i'
                [isNew]='false'
                [isBusy]='isBusy'
                (valueChanged)='loadDetails()'
                [authorityTypesForBuildingServiceLevel]='authorityTypesForBuildingServiceLevel'>
              </app-form-role-details>
            </li>
          }
          <li class='or-stacked-item or-roles-list-item'>
            <app-form-role-details [building]='building'
              [index]='0'
              [isNew]='true'
              [isBusy]='isBusy'
              (valueChanged)='loadDetails()'
              [authorityTypesForBuildingServiceLevel]='authorityTypesForBuildingServiceLevel'>
            </app-form-role-details>
          </li>
        </ul>
      </div>
    }
  </div>
</div>
